import User from '../models/User';
import { rolPermission, stateTask } from './functions';
import Task from '../models/Task';

export const canEditGeometries = (task: Task): boolean => {
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser')!);
  return (currentUser.rol.permiso === rolPermission.COORDINACION ||
      currentUser.rol.permiso === rolPermission.AUTOGESTION) &&
    ([stateTask.CREADA, stateTask.ASIGNADA].includes(task.estado!));
};
